import * as classNames from 'classnames'

export const getColorClass = (
  colorKey: string | undefined,
  prefix: 'backgroundColour' | 'colour',
  classes: classNames.Mapping
): string => {
  if (colorKey) {
    const key = colorKey.replaceAll('/', '').replace('UI', 'Ui')
    return (classes[`${prefix}${key}`] || '') as string
  }
  return ''
}
